import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import './index.css';
import { UserProvider } from './contexts/UserContext';
import { EventProvider } from './contexts/EventContext';
import { API_BASE_URL } from './config/apiBase';
import { bearerFromHeaders, shouldEndAdminSession } from './utils/sessionGuard';

// O bundle usa /api quando REACT_APP_API_URL não está definido.
// Em desenvolvimento o proxy do CRA encaminha /api ao backend.
// No Docker o nginx faz o mesmo encaminhamento.

// Interceptor para adicionar token em todas as requisições
axios.interceptors.request.use(
  (config) => {
    // Apenas adicionar token se a URL for para nossa API
    if (config.url?.startsWith(API_BASE_URL) || config.url?.startsWith('/api')) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas e erros
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const errorMessage = error.response?.data?.message || '';
    const requestToken = bearerFromHeaders(error.config?.headers);
    const currentToken = localStorage.getItem('token');

    if (shouldEndAdminSession({
      status,
      message: errorMessage,
      requestToken,
      currentToken,
    })) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      const path = window.location.pathname;
      if (path !== '/login' && path !== '/' && path !== '/hackathon') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

const defaultGoogleClientId = '1073195925193-u0vsks5diemiuviv5e5pufuupouh2f51.apps.googleusercontent.com';
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || defaultGoogleClientId;

console.log('Google Client ID configurado:', googleClientId ? 'Sim' : 'Não');

// Verificar se o clientId está válido
if (!googleClientId || googleClientId === '') {
  console.error('❌ ERRO: Google Client ID não configurado!');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider 
    clientId={googleClientId}
    onScriptLoadError={() => console.error('❌ Erro ao carregar script do Google OAuth')}
    onScriptLoadSuccess={() => console.log('✅ Script do Google OAuth carregado com sucesso')}
  >
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <React.StrictMode>
        <UserProvider>
          <EventProvider>
            <App />
          </EventProvider>
        </UserProvider>
      </React.StrictMode>
    </ThemeProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();
